import { FC, HTMLAttributes, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Sounds } from "types/sound";
import { useSoundStore } from "utils/sound-store";
import { useCountdown } from "usehooks-ts";

const Container = styled.div`
  position: absolute;
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-image: linear-gradient(to bottom, #78788e, #434355 21%, #fff 53%, #434455 78%, #75768a);
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.5);
  left: calc((100% - 70px) / 2);
  top: calc((100% - 93px) / 2);
  pointer-events: none;
  z-index: 0;

  &::before {
    position: absolute;
    content: "";
    left: 1px;
    top: 1px;
    width: calc(100% - 2px);
    height: calc(100% - 2px);
    border-radius: 50%;
    background-color: #000;
    z-index: -1;
  }
`;

const Count = styled.h1`
  font-family: DS-Digital;
  font-size: 3rem;
  font-weight: 700;
  color: #f00;
  text-align: center;
  line-height: 1;
  margin: 2px auto 0;
`;

const Text = styled.p`
  font-family: DS-Digital;
  font-size: 1rem;
  font-weight: 700;
  line-height: 0.6;
  letter-spacing: 1.77px;
  text-align: center;
  color: #fff;
  margin: 0 auto;
`;

export type TimerProps = HTMLAttributes<HTMLDivElement> & {
  seconds: number;
  onFinish: () => void;
};

export const Timer: FC<TimerProps> = ({ seconds, onFinish, ...props }) => {
  const { t } = useTranslation();
  const play = useSoundStore(store => store.play);
  const stop = useSoundStore(store => store.stop);
  const [count, { startCountdown, stopCountdown }] = useCountdown({ countStart: seconds });

  useEffect(() => {
    play(Sounds.Countdown);

    return() => {
      stop(Sounds.Countdown);
      stopCountdown();
    };
  }, []);

  useEffect(() => {
    if(seconds > 0) {
      startCountdown();
    }
  }, [seconds, startCountdown]);

  useEffect(() => {
    if(!count) onFinish();
  }, [count, onFinish]);

  return (
    <Container>
      <Count>{count}</Count>
      <Text>{t('SEC')}</Text>
    </Container>
  );
};
